import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  setCourseFailed,
  setCourse,
  clearError,
  getAllCourseSuccess,
  getAllCourseFailure,
} from '../actions';
import { CoursesActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

export function* fetchCourse({ data }) {
  const { pageNumber, pageSize } = data;
  const finalPage = pageNumber;
  const url = `${API_BASE_URL}/courses?&page=${finalPage}&size=${
    pageSize || 10
  }`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(clearError());
    yield put(setCourse(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(setCourseFailed(response.message));
  }
}

export function* fetchAllCourse() {
  const url = `${API_BASE_URL}/courses?&fetch=ALL`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(clearError());
    yield put(getAllCourseSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, response?.message);
    yield put(getAllCourseFailure(response.message));
  }
}

export function* watchCourse() {
  yield takeEvery(CoursesActionTypes.GET_ALL_COURSES, fetchAllCourse);
  yield takeEvery(CoursesActionTypes.GET_COURSES, fetchCourse);
}
